import { Box, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Banner, JoinUs, ReasonsToChooseUs, WeDo, AchievementsSection } from "src/components/home";
import { Layout, Sidebar } from "src/components/common";

export const HomePage: React.FC = () => {
  const theme = useTheme();
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  const [sectionHeights, setSectionHeights] = useState<number[]>([]);
  const smallLg = useMediaQuery(theme.breakpoints.down("lg"));

  useEffect(() => {
    const heights = sectionRefs.current.map(el => el?.offsetHeight ?? 0);
    setSectionHeights(heights);
  }, []);

  return (
    <Layout>
      <Box
        sx={{
          width: "100vw",
          overflowX: "clip",
          zIndex: 99,
          position: "relative",
          transform: `translateY(0px)`,
        }}
      >
        <Box
          id="section-0"
          ref={(el: HTMLDivElement) => {
            sectionRefs.current[0] = el;
          }}
        >
          <Banner />
        </Box>
        <Box
          id="section-1"
          ref={(el: HTMLDivElement) => {
            sectionRefs.current[1] = el;
          }}
        >
          <WeDo />
        </Box>
        <Box
          id="section-2"
          ref={(el: HTMLDivElement) => {
            sectionRefs.current[2] = el;
          }}
        >
          <ReasonsToChooseUs />
        </Box>
        <Box
          id="section-3"
          ref={(el: HTMLDivElement) => {
            sectionRefs.current[3] = el;
          }}
        >
          <AchievementsSection />
        </Box>
        <Box
          id="section-4"
          ref={(el: HTMLDivElement) => {
            sectionRefs.current[4] = el;
          }}
        >
          <JoinUs />
        </Box>
      </Box>
      {!smallLg && sectionHeights.length > 0 && <Sidebar sectionHeights={sectionHeights} />}
    </Layout>
  );
};

export default HomePage;
